import { SET_TAB_KEY } from '../../common/constants/ActionConstants';
import Session, { APPLICATION_TYPE } from '../../common/services/Session';

export const setRedirectTabAction = (pathname) => {
  const search = Session.get(APPLICATION_TYPE) === 'LO' ? '?App=LO' : ''; //  TODO(ngen): do we really need this at all? app type should be checked once at load, doesn't need to remain persisted everywhere.
  try {
    throw new Error('Unsupported redirect');
  } catch (err) {
    console.error(
      'Unsupported redirect. Trace it here, and refactor it to use useNavigate hooks',
      err,
    );
  }
  return {
    type: SET_TAB_KEY,
    payload: pathname,
  };
};
